import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainComponent } from '../../app/main.component';

const routes: Routes = [
  {
    path: '',
    component: MainComponent
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [RouterModule],
  providers: []
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/config/routing/app-routing.module.ts